import productSizeApi from "../../api/product/productSizeApi";

const ProductSizeService = {
    /**
     * Obtener todas las tallas registradas.
     */
    getAll: async () => {
        try {
            const response = await productSizeApi.fetchAll();
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Obtener tallas activas para un menú desplegable.
     */
    getDropdown: async () => {
        try {
            const response = await productSizeApi.fetchCustom('/dropdown');
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
 * Buscar tallas activas para dropdown (code/name).
 */
    searchDropdown: async (query: string) => {
        try {
            const response = await productSizeApi.fetchCustom(
                `/dropdown/search?query=${encodeURIComponent(query)}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    },


    /**
     * Obtener una talla por ID.
     */
    getById: async (id: number) => {
        try {
            const response = await productSizeApi.fetchById(id);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Buscar tallas por código o nombre.
     */
    search: async (query: string) => {
        try {
            const response = await productSizeApi.fetchCustom(`/search?query=${query}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Crear una nueva talla.
     */
    save: async (data: Object) => {
        try {
            const response = await productSizeApi.add(data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Actualizar una talla existente.
     */
    update: async (id: number, data: Object) => {
        try {
            const response = await productSizeApi.modify(id, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Activar o desactivar una talla.
     */
    toggleStatus: async (id: number) => {
        try {
            const response = await productSizeApi.patchCustom(`${id}/toggle-status`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
};

export default ProductSizeService;
